export const liveChatComponentsStyles = `

/* ========================================
   MESSAGES
   ======================================== */

.liveChat-message {
  display: flex;
  gap: var(--spacing-2);
  max-width: 75%;
}

.liveChat-message-system {
  align-self: center;
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2) 0;
  width: 100%;
}

.liveChat-message-system::before,
.liveChat-message-system::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--msg-border);
}

.liveChat-message-system-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--msg-text-secondary);
  white-space: nowrap;
  padding: 0 var(--spacing-2);
}

/* Rich join/leave system event */
.liveChat-message-system-event {
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: var(--spacing-3) 0;
  width: 100%;
  text-align: center;
}

.liveChat-message-system-event-avatar {
  width: 3rem;
  height: 3rem;
  border-radius: var(--radius-full);
  border: 1px solid var(--msg-border);
  background: var(--msg-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  overflow: hidden;
  flex-shrink: 0;
  margin-bottom: 4px;
}

.liveChat-message-system-event-avatar img {
  width: 60%;
  height: 60%;
  object-fit: contain;
}

.liveChat-message-system-event-name {
  font-size: 0.875rem;
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: 1.3;
}

.liveChat-message-system-event-action {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--msg-text-secondary);
  margin-top: -2px;
}

.liveChat-message-system-event-time {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--msg-text-tertiary);
}

.liveChat-message-own {
  align-self: flex-end;
  flex-direction: column;
  align-items: flex-end;
}

.liveChat-message-received {
  align-self: flex-start;
  flex-direction: column;
}

.liveChat-message-row {
  display: flex;
  align-items: flex-end;
  gap: var(--spacing-2);
}

.liveChat-message-wrapper {
  display: flex;
  flex-direction: column;
}

.liveChat-message-avatar {
  display: none;
}

.liveChat-message-sender {
  display: none;
}

.liveChat-message-bubble {
  padding: 7px 13px;
  border-radius: 1.125rem;
  word-wrap: break-word;
  max-width: 100%;
}

.liveChat-message-own .liveChat-message-bubble {
  background: var(--msg-bg-bubble-own);
  color: var(--msg-text, #111827);
  border-bottom-right-radius: 0.25rem;
}

.liveChat-message-received .liveChat-message-bubble {
  background: var(--msg-bg-bubble-received);
  color: #ffffff;
  border-bottom-left-radius: 0.25rem;
}

.liveChat-message-content {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: var(--line-height-relaxed);
}

.liveChat-message-content p {
  margin: 0 0 0.5rem;
}

.liveChat-message-content p:last-child {
  margin-bottom: 0;
}

.liveChat-message-time {
  font-size: var(--font-size-xs);
  color: var(--msg-text-tertiary);
  margin-top: 0.25rem;
  padding: 0 var(--spacing-1);
}

.liveChat-message-meta {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: var(--font-size-xs);
  color: var(--msg-text-tertiary);
  margin-top: 0.25rem;
  padding: 0 var(--spacing-1);
}

.liveChat-message-meta-own {
  justify-content: flex-end;
}

.liveChat-message-sent-status {
  color: var(--msg-text-muted);
}

.liveChat-message-optimistic .liveChat-message-bubble {
  opacity: 0.7;
}

.liveChat-message-image {
  max-width: 220px;
  max-height: 200px;
  width: auto;
  height: auto;
  border-radius: var(--radius-lg);
  margin-top: var(--spacing-1);
  cursor: pointer;
  object-fit: contain;
  display: block;
}

.liveChat-message-file {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-top: var(--spacing-1);
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-lg);
  background: var(--color-neutral-100);
  color: var(--color-primary);
  text-decoration: none;
  font-size: var(--font-size-sm);
  transition: background var(--transition-base);
  max-width: 100%;
  word-break: break-all;
  cursor: pointer;
}

.liveChat-message-file:hover {
  background: var(--color-neutral-200);
}

.liveChat-file-download-icon {
  margin-left: auto;
  opacity: 0.5;
  flex-shrink: 0;
}

.liveChat-message-file:hover .liveChat-file-download-icon {
  opacity: 1;
}

.liveChat-closed-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-4);
  margin: var(--spacing-4);
  background: var(--color-success-light);
  color: var(--color-success-dark);
  border-radius: var(--radius-xl);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}

/* ========================================
   SCROLL PILL & CONNECTION BANNER
   ======================================== */

.liveChat-scroll-pill {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: 6px 14px;
  background: var(--color-primary);
  color: #ffffff;
  font-size: var(--font-size-xs);
  font-weight: 500;
  border-radius: var(--radius-full);
  cursor: pointer;
  box-shadow: var(--shadow-lg);
  z-index: 10;
  white-space: nowrap;
}

.liveChat-connection-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: 6px var(--spacing-4);
  background: #fef3c7;
  color: #92400e;
  font-size: var(--font-size-xs);
  font-weight: 500;
  flex-shrink: 0;
}

.liveChat-widget.theme-dark .liveChat-connection-banner {
  background: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
}

/* ========================================
   CHAT HEADER
   ======================================== */

.liveChat-chat-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-4);
  border-bottom: 1px solid var(--msg-border);
}

.liveChat-chat-header-avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: var(--radius-lg);
  background: var(--msg-bg-surface);
  border: 1px solid var(--msg-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  padding: 4px;
}

.liveChat-chat-header-avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.liveChat-chat-header-avatar svg {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--msg-text-secondary);
}

.liveChat-chat-header-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.liveChat-chat-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: 1.4;
}

.liveChat-chat-subtitle {
  font-size: var(--font-size-sm);
  color: var(--msg-text-secondary);
  line-height: 1.4;
}

.liveChat-chat-header-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.liveChat-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-5) var(--spacing-4);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.liveChat-chat-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--spacing-10);
}

.liveChat-chat-empty-avatars {
  margin-bottom: var(--spacing-4);
}

.liveChat-chat-empty-logo {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-xl);
  overflow: hidden;
  margin-bottom: var(--spacing-4);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--msg-bg-surface);
}

.liveChat-chat-empty-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.liveChat-chat-empty h3 {
  margin: 0 0 var(--spacing-2);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
}


/* ========================================
   COMPOSE AREA
   ======================================== */

/* ========================================
   EMOJI PICKER
   ======================================== */

.liveChat-emoji-picker-container {
  padding: 0 var(--spacing-3) var(--spacing-2);
}

.liveChat-emoji-picker-container emoji-picker {
  width: 100%;
  height: 320px;
  border-radius: var(--radius-xl);
  border: 1px solid var(--msg-border);
  box-shadow: var(--shadow-lg);

  --background: var(--msg-bg);
  --border-color: var(--msg-border);
  --border-radius: 12px;
  --category-font-color: var(--msg-text-secondary);
  --category-font-size: 0.7rem;
  --emoji-size: 1.35rem;
  --emoji-padding: 0.3rem;
  --input-border-color: var(--msg-border);
  --input-border-radius: 8px;
  --input-font-color: var(--msg-text);
  --input-font-size: 0.8rem;
  --input-placeholder-color: var(--msg-text-tertiary);
  --input-padding: 0.375rem 0.625rem;
  --outline-color: var(--color-primary);
  --num-columns: 8;
  --indicator-color: var(--color-primary);
  --hover-background: var(--msg-bg-hover);
}

.liveChat-widget.theme-dark .liveChat-emoji-picker-container emoji-picker {
  --background: var(--msg-bg);
  --border-color: var(--msg-border);
  --category-font-color: var(--msg-text-secondary);
  --input-font-color: var(--msg-text);
  --input-placeholder-color: var(--msg-text-tertiary);
  --hover-background: var(--msg-bg-hover);
}

.liveChat-chat-compose {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-3) var(--spacing-4);
  background: var(--msg-bg);
  margin: 0 var(--spacing-3) var(--spacing-3);
  border: 1px solid var(--msg-border);
  border-radius: var(--radius-xl);
}

.liveChat-compose-input-wrapper {
  width: 100%;
}

.liveChat-compose-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  color: var(--msg-text);
  font-size: var(--font-size-base);
  line-height: var(--line-height-relaxed);
  resize: none;
  max-height: 120px;
  font-family: inherit;
  padding: var(--spacing-1) 0;
}

.liveChat-compose-input::placeholder {
  color: var(--msg-text-tertiary);
}

.liveChat-compose-input:focus {
  outline: none;
}

.liveChat-chat-compose:focus-within {
  border-color: var(--color-primary-border);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}

.liveChat-compose-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--spacing-2);
}

.liveChat-compose-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.liveChat-compose-send {
  width: 2.25rem;
  height: 2.25rem;
  background: transparent;
  border: 1px solid var(--msg-border);
  border-radius: var(--radius-full);
  color: var(--msg-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-base);
  flex-shrink: 0;
}

.liveChat-compose-send:hover:not(:disabled) {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--msg-bg);
}

.liveChat-compose-send:active:not(:disabled) {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-compose-send:disabled {
  color: var(--color-neutral-300);
  border-color: var(--color-neutral-200);
  cursor: not-allowed;
}

.liveChat-compose-send svg {
  color: inherit;
}

.liveChat-compose-file-input {
  display: none;
}

.liveChat-compose-attach {
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  color: var(--msg-text-secondary);
}

.liveChat-compose-attach:hover {
  color: var(--msg-text);
}

.liveChat-compose-attach svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* ========================================
   TYPING INDICATOR
   ======================================== */

.liveChat-typing-indicator {
  display: none;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-3);
  margin: var(--spacing-1) 0;
}

.liveChat-typing-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--color-neutral-100);
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-2xl);
}

.liveChat-typing-dots span {
  width: 6px;
  height: 6px;
  background: var(--color-neutral-400);
  border-radius: var(--radius-full);
  animation: liveChat-typing-bounce 1.4s infinite ease-in-out;
}

.liveChat-typing-dots span:nth-child(1) { animation-delay: -0.32s; }
.liveChat-typing-dots span:nth-child(2) { animation-delay: -0.16s; }
.liveChat-typing-dots span:nth-child(3) { animation-delay: 0s; }

.liveChat-typing-text {
  font-size: var(--font-size-xs);
  color: var(--msg-text-tertiary);
}

/* ========================================
   NAVIGATION TABS
   ======================================== */

.liveChat-panel-nav {
  border-top: 1px solid var(--msg-border);
  background: var(--msg-bg);
}

.liveChat-nav-tabs {
  display: flex;
  padding: var(--spacing-1) var(--spacing-2) 0;
  gap: var(--spacing-1);
}

.liveChat-nav-footer {
  padding: 2px var(--spacing-2) var(--spacing-2);
  text-align: center;
}

.liveChat-powered-by {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: var(--msg-text-tertiary);
  text-decoration: none;
  transition: color var(--transition-base);
}

.liveChat-powered-by:hover {
  color: var(--msg-text-secondary);
}

.liveChat-powered-by svg {
  width: 12px;
  height: 14px;
}

.liveChat-powered-by strong {
  font-weight: var(--font-weight-semibold);
}

.liveChat-nav-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: var(--spacing-1) var(--spacing-1);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: all var(--transition-base);
  position: relative;
}

.liveChat-nav-tab:hover {
  background: transparent;
}

.liveChat-nav-tab:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-nav-tab:hover .liveChat-nav-icon,
.liveChat-nav-tab:hover .liveChat-nav-label {
  color: var(--msg-text);
}

.liveChat-nav-icon {
  color: var(--msg-text-secondary);
  transition: color var(--transition-base);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
}

.liveChat-nav-icon svg {
  width: 26px;
  height: 26px;
  display: block;
}

.liveChat-nav-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--msg-text-secondary);
  transition: color var(--transition-base);
}

.liveChat-nav-tab.active .liveChat-nav-icon,
.liveChat-nav-tab.active .liveChat-nav-label {
  color: var(--color-primary);
}

.liveChat-nav-badge {
  position: absolute;
  top: var(--spacing-1);
  right: calc(50% - 16px);
  min-width: 16px;
  height: 16px;
  background: var(--color-error);
  color: var(--msg-bg);
  font-size: 10px;
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 var(--spacing-1);
}

/* ========================================
   PRECHAT
   ======================================== */

.liveChat-prechat-view {
  position: relative;
}

.liveChat-prechat-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-5);
  z-index: var(--z-popover);
  backdrop-filter: blur(2px);
}

.liveChat-prechat-card {
  background: var(--msg-bg);
  border-radius: var(--radius-xl);
  padding: var(--spacing-6) var(--spacing-6) var(--spacing-5);
  width: 100%;
  max-width: 320px;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--msg-border);
  text-align: center;
}

.liveChat-prechat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: var(--radius-full);
  background: var(--color-primary-light);
  color: var(--color-primary);
  margin: 0 auto var(--spacing-4);
}

.liveChat-prechat-title {
  margin: 0 0 var(--spacing-2);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
}

.liveChat-prechat-subtitle {
  margin: 0 0 var(--spacing-5);
  font-size: var(--font-size-sm);
  color: var(--msg-text-secondary);
  line-height: var(--line-height-relaxed);
}

.liveChat-prechat-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.liveChat-prechat-field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.liveChat-prechat-input {
  width: 100%;
  padding: var(--spacing-2) var(--spacing-3);
  border: 1px solid var(--msg-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-family: inherit;
  background: var(--msg-bg-surface);
  color: var(--msg-text);
  outline: none;
  transition: border-color var(--transition-fast);
  box-sizing: border-box;
}

.liveChat-prechat-input::placeholder {
  color: var(--msg-text-secondary);
}

.liveChat-prechat-input:focus {
  border-color: var(--color-primary);
}

.liveChat-prechat-error {
  font-size: var(--font-size-xs);
  color: #dc2626;
}

.liveChat-prechat-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-3);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  font-family: inherit;
  cursor: pointer;
  transition: all var(--transition-fast);
  border: none;
  width: 100%;
  background: var(--color-primary);
  color: #ffffff;
  margin-top: var(--spacing-1);
}

.liveChat-prechat-submit:hover {
  background: var(--color-primary-hover);
}

.liveChat-prechat-submit:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-prechat-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ========================================
   FEEDBACK FORM VIEW
   ======================================== */

.liveChat-feedback-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.liveChat-feedback-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: var(--spacing-4) var(--spacing-4);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.liveChat-feedback-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.liveChat-feedback-body {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-5) var(--spacing-4);
  flex: 1;
  overflow-y: auto;
}

.liveChat-feedback-body .sdk-form-group {
  margin-bottom: 0;
}

.liveChat-feedback-prompt {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.liveChat-feedback-error {
  font-size: var(--font-size-xs);
  color: #ef4444;
  margin-top: calc(var(--spacing-2) * -1);
}

.liveChat-feedback-thankyou {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: var(--spacing-6) var(--spacing-4);
  text-align: center;
  gap: var(--spacing-3);
}

.liveChat-feedback-success-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #037F0C;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-2);
}

.liveChat-feedback-thankyou h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.liveChat-feedback-thankyou p {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.liveChat-feedback-done-btn {
  margin-top: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-5);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  font-family: inherit;
  cursor: pointer;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.liveChat-feedback-done-btn:hover {
  background: var(--bg-secondary);
}
`;
